import { render, staticRenderFns } from "./FromToDatePrdModal.vue?vue&type=template&id=f83d2480&"
import script from "./FromToDatePrdModal.vue?vue&type=script&lang=js&"
export * from "./FromToDatePrdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports